import { filterConfiguration } from 'app/components/filters/filters-panel/filter-configuration';
import { FilterTypes, OptionTypes, ConditionValuesOperator, Filter } from 'app/components/filters/types';
import { FilterText } from 'app/components/filters/filters-panel/filter-types/filter-text/filter-text';
import { FavouriteCondition } from 'app/types-shared';
import { createFavouriteCondition } from 'app/components/filters/filters-panel/conditions/create-conditions';
import { createConditionValue } from './create-condition-value';
import { createConditionOptionTypeValue } from './create-condition-option-type-value';
import { createConditionSubOptionTypeValue } from './create-condition-sub-option-type-value';

export const textFieldConfiguration = {
  [FilterTypes.TextField]: filterConfiguration(FilterText)
};

export const textFieldConditionMapper = (editingValues: any) => {
  return {
    [FilterTypes.TextField]: (filter: Filter) => {
      let condValIndex = 1;

      const editingValue = editingValues && editingValues[filter.id];
      const value = editingValue && editingValue.value;

      const conditionValue = createConditionValue(condValIndex++, filter, value);
      const conditionOptionTypeValue = createConditionOptionTypeValue(condValIndex++, filter);
      const conditionSubOptionTypeValue = createConditionSubOptionTypeValue(condValIndex++, filter, value);
      const conditionValues = (!conditionSubOptionTypeValue && conditionValue) || conditionSubOptionTypeValue || conditionOptionTypeValue;
      const originalCondition = filter.conditions && filter.conditions[0];

      return conditionValues ? [createFavouriteCondition(filter, conditionValues, originalCondition)] : [];
    }
  };
};

export const textFieldOptionType = (condition: FavouriteCondition) => {

  if (condition.values && condition.values.some(v => v.operator && v.operator.v === ConditionValuesOperator.empty)) {
    return {
      [FilterTypes.TextField]: OptionTypes.NotSpecified
    };
  }

  return {
    [FilterTypes.TextField]: OptionTypes.ContainsWords
  };
};
